<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <h3>Profile</h3>
    <div
      style="width: 480px"
      class="ui selection dropdown"
      suiDropdown
      [(ngModel)]="selectedProfile"
      (ngModelChange)="onProfileChange()"
    >
      <input type="hidden" name="profile" />
      <i
        style="position: absolute; right: 1rem; font-size: 1.2rem"
        class="angle down icon"
      ></i>
      <div class="default text">Select Geofence Profile</div>
      <div class="menu" suiDropdownMenu>
        <div
          (click)="assignGeofenceUser(profile)"
          class="item"
          *ngFor="let profile of profiles"
          [attr.data-value]="profile.geoFenceProfileId"
        >
          {{ profile.profileName }}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
</div>
